import type { ReactElement, SVGProps } from 'react';

import type { IconSVGProps } from './types';

/**
 * JobIcon: ícono para “empleo / trabajo”.
 */
export const JobIcon = ({
  className,
  width = 16,
  height = 17,
  ...props
}: IconSVGProps): ReactElement<SVGProps<SVGSVGElement>> => {
  return (
    <svg
      viewBox="0 0 16 17"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      aria-hidden
      focusable="false"
      {...props}
    >
      <path
        d="M4 15.5H12V3C12 2.17188 11.3281 1.5 10.5 1.5H5.5C4.67188 1.5 4 2.17188 4 3V15.5ZM6 3.5H10V4.5H6V3.5ZM16 6V14C16 14.8281 15.3281 15.5 14.5 15.5H13V4.5H14.5C15.3281 4.5 16 5.17188 16 6ZM3 15.5H1.5C0.671875 15.5 0 14.8281 0 14V6C0 5.17188 0.671875 4.5 1.5 4.5H3V15.5Z"
        fill="inherit"
      />
    </svg>
  );
};
